import { Pipe, PipeTransform } from '@angular/core';
import { Realisation, RealisationHourtype } from 'src/app/classes/realisation';

@Pipe({ name: 'isTraveltime' })
export class IsTraveltimePipe implements PipeTransform {
    transform(realisation: Realisation): boolean {
        return [RealisationHourtype.travel_to, RealisationHourtype.travel_back].includes(realisation.hourtype);
    }
}
